import fp from "lodash/fp";

import { BusinessInfo } from "models";
import { ACHProcessorValues } from "models/application/achProcessorValues";
import { applicationListConstants } from "store";
import { withResetState } from "store/hocs";

import { businessInfoConstants } from "./businessInfo.constants";

const values = new BusinessInfo();
const achValues = new ACHProcessorValues();

const initialState = {
	applicationId: "",
	error: "",
	minDalivery: false,
	avgDalivery: false,
	maxDalivery: false,
	businessInfoForm: {},
	isWebSiteValidationPending: false,
	isWebSiteBeingValidated: false,
	websiteError: "",
	websiteInformation: null,
	updateWebSiteloading: false,
	...values,
	...achValues,
	banks: [],
	billingBanks: [],
};

export const getBusinessInfoState = state => state.businessInfo;

// prettier-ignore
const selector = property =>
	fp.flow(getBusinessInfoState, fp.property(property));

export const getBanks = selector("banks");
export const getBillingBanks = selector("billingBanks");

function businessInfo(state = initialState, action) {
	switch (action.type) {
		case applicationListConstants.RESET_APPLICATION_ENTRY_STATE:
			return {
				...initialState,
			};
		case applicationListConstants.RESET_APPLICATION_EDIT_STATE:
			return {
				...initialState,
			};
		case businessInfoConstants.SET_VALUE:
			let values = Object.assign({}, state.values);
			values[action.name] = action.value;
			return {
				...state,
				values: values,
			};
		case businessInfoConstants.SET_DAYS_TO_DELIVERY:
			return {
				...state,
				[action.name]: action.value,
			};
		case businessInfoConstants.SET_BANKS:
			return {
				...state,
				banks: action.banks,
			};
		case businessInfoConstants.SET_BILLING_BANKS:
			return {
				...state,
				billingBanks: action.billingBanks,
			};
		case businessInfoConstants.WEB_SITE_CHECK_REQUEST:
			return {
				...state,
				isWebSiteValidationPending: true,
				isWebSiteBeingValidated: false,
				websiteError: "",
			};
		case businessInfoConstants.WEB_SITE_CHECK_SUCCESS:
			const websiteError =
				action.website &&
				(action.website?.checkedSuccessfully === false ||
					action.website?.isSuccessfully === false)
					? "Website was not found"
					: "";
			const isWebSiteValid = action.isValidated
				? action.website?.isSuccessfully
				: action.website?.checkedSuccessfully;
			return {
				...state,
				websiteError,
				isWebSiteValidationPending: false,
				isWebSiteBeingValidated: action.isValidated ? true : false,
				websiteInformation: {
					url: action.website?.url,
					screenshotUrl: action.website?.screenshotUrl,
					title: action.website?.title,
					checkedSuccessfully: isWebSiteValid,
				},
			};
		case businessInfoConstants.WEB_SITE_CHECK_ERROR:
			return {
				...state,
				websiteError: action.error,
				isWebSiteValidationPending: false,
				isWebSiteBeingValidated: true,
				websiteInformation: null,
			};
		case businessInfoConstants.UPDATE_WEB_SITE_INFORMATION_REQUEST:
			return {
				...state,
				updateWebSiteloading: true,
			};
		case businessInfoConstants.UPDATE_WEB_SITE_INFORMATION_SUCCESS:
			return {
				...state,
				updateWebSiteloading: false,
			};
		default:
			return state;
	}
}

export default withResetState({ initialState })(businessInfo);
